<template>
    <div :id="divName"></div>
</template>

<script setup>
  import {ref, onMounted, watch, toRefs, computed } from "vue";
  import * as d3 from 'd3';

  const props = defineProps({
    name:{type: String, default: null},
    divName:{type: String},
    colors:{type:Object},
    data:{type:Object},
    radius: {type: Number, default: 20}
  })

  const { divName, data, radius, colors } = toRefs(props)

  const donutWidth = ref(230)
  const donutHeight = ref(200)

  onMounted(() => {
    updateDonut()
  })
  watch(data, (newVal, oldVal)=>{
    if (JSON.stringify(newVal) !== JSON.stringify(oldVal)){
      updateDonut()
    }
  })


  const updateDonut = () => {
    const chartSelector = divName.value;
    const colorsObj = colors.value;

    const donutData = data.value;
    // console.log(donutData)

    //get the total area
    const areas = []
    Object.keys(donutData).forEach((type, i) => {
      areas.push(donutData[type])
    });



    const totalArea = areas.reduce((a, b) => a + b, 0)

    d3.select("#" + chartSelector).select("svg").remove();
    // set the dimensions and margins of the graph
    const width = donutWidth.value
    const height = donutHeight.value
    const margin = 40

    // The radius of the pieplot is half the width or half the height (smallest one). I subtract a bit of margin.
    // Adjusting the denominator will size the donut in the div.  Small number-- bigger donut
    const radiusUse = radius.value //Math.min(width, height) / 1.45 - margin

    // append the svg object to the div '
    const svg = d3.select('#' + chartSelector)
      .append('div')
        .classed("svg-container", true)
      .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("viewBox", "0 0 " + width + " " + height)
        .classed("svg-content-responsive", true)
      .append("svg")
        .attr("width", width)
        .attr("height", height)

    .append("g")
      .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");


    // set the color scale
    // const color = d3.scaleOrdinal()
    //   .domain(data)
    //   .range(colors)

    // Compute the position of each group on the pie:
    const pie = d3.pie()
      .value(function(d) {return d.value; })
      // console.log(donutData)

    // this replaces d3.entries
    const processed_data = []
    for (const [key, value] of Object.entries(donutData)) {
      processed_data.push({key : key, value : value})
    }

    const data_ready = pie(processed_data)
    // console.log(data_ready)

    // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
    svg
      .selectAll('whatever')
      .data(data_ready)
      .enter()
      .append('path')
        .attr('d', d3.arc()
          .innerRadius(-25)         // This is the size of the donut hole
          .outerRadius(radiusUse)
        )
    .attr('fill', function(d){
      // console.log(d.data.key)
      return(colorsObj[d.data.key])
    })
    .attr("class", "donutArc")
    .attr("stroke", "black")
    .style("stroke-width", "2px")
    .style("opacity", 0.7)

    // Animation
    svg.selectAll(".donutArc")
      .transition()
      .duration(500)
      .attr('d', d3.arc()
        .innerRadius(75)         // This is the size of the donut hole
        .outerRadius(radiusUse)
      )
      .delay(function(d,i){ return(i*10)})

    //tooltips
    let tooltip = d3.select("body")
      .append("div")
      .style("position", "absolute")
      .style("z-index", "10")
      .style("visibility", "hidden")
      .attr("class", "tooltip")
      // .style("background-color", "#ffffff")
      .style("border", "solid")
      .style("border-width", "1px")
      .style("border-radius", "5px")
      .style("padding", "3px")
      .style("font-family", "sans-serif")

      let paths = svg.selectAll("path")
        .on("mouseover", function(e){
          let v = e.target.__data__
          tooltip
          .html(( "<b>" + v.data.key) + "</b>: " + Math.round(v.data.value/totalArea*100) + "%") // The first <a> tag
          .style("opacity", 1)
          .style("font", "14px sans-serif")
          .style("z-index", 9999)
          return tooltip.style("visibility", "visible");
        })
        .on("mousemove", function(e){return tooltip
          .style("top", (e.pageY -15)+"px")
          .style("left",(e.pageX +12)+"px")

          ;})
        .on("mouseout", function(){return tooltip
          .style("visibility", "hidden")
        ;})
        .on("wheel", function(){return tooltip
          .style("visibility", "hidden")
        ;})
        .on("mousezoomin.zoom", function(){return tooltip
          .style("visibility", "hidden")
        ;})
        .on("mousezoomout.zoom", function(){return tooltip
          .style("visibility", "hidden")
        ;})
        .on("mousewheel.zoom", function(){return tooltip
          .style("visibility", "hidden")
        ;})
        .on("mouseup", function(){return tooltip
          .style("visibility", "hidden")
        ;})
        .on("mousewheel", function(){return tooltip
          .style("visibility", "hidden")
        ;})
        .on("mousezoomout", function(){return tooltip
          .style("visibility", "hidden")
        ;})
        .on("mousezoomin", function(){return tooltip
          .style("visibility", "hidden")
        ;})

  }


// const colors = ref({
//   "Depression/valley": '#7A8EF5',
//   "Valley peaks": '#444F89',
//   "Low flat": '#FFFFFF',
//   "Mid flat": '#FFF1BE',
//   "Upper flat/bank": '#FFBEE8',
//   "Upper slope/peak": '#CD6699'
// }),
// const data = ref({
//   "Depression/valley": 2.22,
//   "Low flat": 1.65,
//   "Mid flat": 5.13,
//   "Total Area": 0,
//   "Upper flat/bank": 10.26,
//   "Upper slope/peak": 0.16,
//   "Valley peaks": 0
// })

</script>
<style >
.q-dark .tooltip{
  background-color: #2e2e2e;
}
.tooltip{
  background-color: white;
  color: black
}
.q-dark &.tooltip{
  background-color: #2e2e2e;
}
</style>
